<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}{{ route.menuName }}</span>
        <span style="color: red"> {{ form.supplierApproveStateInfo }}</span>
      </div>
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">基础信息</span>
          </div>
          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="no" label="申请单号" v-if="getIsView()">
                <el-input disabled v-model="form.no"></el-input>
              </el-form-item>
              <span class="viewText" v-else>申请单号:{{ form.no }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientNo" label="住院号" v-if="getIsView()">
                <el-select v-model="form.patientNo" filterable :filter-method="getPatientDetailList" @change="patientChange" :disabled="!editMode" style="width: 100%">
                  <el-option v-for="item in STATIC_PatientDetails" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>住院号:{{ form.patientNo }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="bedNo" label="床号" v-if="getIsView()">
                <el-input :disabled="!editMode" v-model="form.bedNo"></el-input>
              </el-form-item>
              <span class="viewText" v-else>床号:{{ form.bedNo }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientId" label="患者姓名" v-if="getIsView()">
                <el-input disabled v-model="form.patientName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>患者姓名:{{ form.patientName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientSexName" label="患者性别" v-if="getIsView()">
                <el-input disabled v-model="form.patientSexName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>患者性别:{{ form.patientSexName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="patientAge" label="患者年龄" v-if="getIsView()">
                <el-input disabled v-model="form.patientAge"></el-input>
              </el-form-item>
              <span class="viewText" v-else>患者年龄:{{ form.patientAge }} </span>
            </el-col>

          </el-row>

          <el-row>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="surgicalName" label="手术名称" v-if="getIsView()">
                <el-input :disabled="!editMode" v-model="form.surgicalName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>手术名称:{{ form.surgicalName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="date" label="手术时间" v-if="getIsView()">
                <el-date-picker v-model="form.date" :disabled="!editMode" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="手术时间" style="width: 100%"></el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>手术时间:{{  parseTime(new Date(form.date), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="doctorName" label="主刀医生" v-if="getIsView()">
                <el-select v-model="form.doctorName" placeholder="请选择" :disabled="!editMode" filterable :filter-method="getUsers" @change="doctorChange" style="width: 100%">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <span class="viewText" v-else>主刀医生:{{ form.doctorName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="createdUserName" label="申请人" v-if="getIsView()">
                <el-input disabled v-model="form.createdUserName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>申请人:{{ form.createdUserName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item prop="ownerDeptName" label="申请科室" v-if="getIsView()">
                <el-input disabled v-model="form.ownerDeptName"></el-input>
              </el-form-item>
              <span class="viewText" v-else>申请科室:{{ form.ownerDeptName }} </span>
            </el-col>
            <el-col :span="4" :class="!getIsView()?'viewCol':''">
              <el-form-item label="创建时间" prop="createdTime" v-if="getIsView()">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 100%">
                </el-date-picker>
              </el-form-item>
              <span class="viewText" v-else>创建时间:{{   parseTime(new Date(form.createdTime), "{y}-{m}-{d} {h}:{i}:{s}") }} </span>
            </el-col>
          </el-row>
          <el-row>
            <!-- <el-col :span="4">
              <el-form-item prop="totalNumber" label="总数量">
                <el-input disabled placeholder="请输入总数量" v-model="form.totalNumber"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item prop="totalAmount" label="总金额">
                <el-input disabled placeholder="请输入总金额" v-model="form.totalAmount"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12" :class="!getIsView()?'viewCol':''">
              <el-form-item label="备注" prop="remark" v-if="getIsView()">
                <el-input :disabled="!editMode" placeholder="备注" v-model="form.remark"></el-input>
              </el-form-item>
              <span class="viewText" v-else>备注:{{ form.remark }} </span>
            </el-col>
          </el-row>
          <el-row style="margin-top: 20px"></el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">申请明细</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" border :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column type="index" width="50" fixed> </el-table-column>
            <el-table-column type="selection" width="55" align="center" fixed></el-table-column>
            <el-table-column prop="productName" label="产品名称" fixed width="180">
              <template slot-scope="scope">
                <SelectTable :disabled="!editMode" :columns="implantsApplyProductColumns" :placeholder="'请选择产品'" :innerName="scope.row.productName" :dataList="STATIC_SupplierProducts" @filterMethod="getProductList" @change="(val) => productChange(scope.row, val)" />
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="specName" label="规格型号" fixed width="180"></el-table-column>
            <el-table-column prop="supplierProductNo" label="供应商产品编码" width="180"></el-table-column>
        
            <el-table-column show-overflow-tooltip prop="manufacturerName" label="生产厂家" width="180"></el-table-column>
            <el-table-column prop="minUnit" label="单位" width="100"></el-table-column>
            <el-table-column prop="number" label="数量" min-width="130">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入数量" type="number" :id="'number' + scope.$index" min="0" @input="childNumberChange(scope.row)" v-model="scope.row.number"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="单价" width="140"></el-table-column>
            <el-table-column prop="amount" label="金额" width="140"></el-table-column>
            <el-table-column prop="productRegistCertNo" show-overflow-tooltip label="注册证号" width="200"></el-table-column>
            <el-table-column prop="productRegistCertName" show-overflow-tooltip label="注册证名称" width="200"></el-table-column>
            <el-table-column prop="medicalInsuranceCategoryNo" show-overflow-tooltip label="医保代码" width="200"></el-table-column>
            <!-- <el-table-column prop="remark" label="备注" min-width="200">
              <template slot-scope="scope">
                <el-input :disabled="!editMode" placeholder="请输入备注" v-model="scope.row.remark"></el-input>
              </template>
            </el-table-column> -->
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom">
      <template v-if="form.state == 2">
        <el-button class="btn primary" type="primary" v-preventReClick @click="confirmOrder">确认订单</el-button>
        <el-button class="btn default" v-preventReClick @click="cancelOrder">取消订单</el-button>
      </template>
      <template v-else>
        <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
        <my-button v-if="editMode && form.status != 0" class="btn primary" type="primary" v-preventReClick @click="proTemSave">暂 存</my-button>
        <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
        <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
        <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  GetImplantsApplyById,
  SaveImplantsApply,
  RejectImplantsApply,
  // CancelImplantsApply,
  ValidateSupplierProducts,
} from "@/api";
// import { InStockOptions, WhetherOptions, AssetSourceOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    SelectTable,
    ApproveInfo,
  },
  data () {
    return {
      GetDataAction: GetImplantsApplyById,
      SaveDataAction: SaveImplantsApply,
      reject: RejectImplantsApply,

      form: {},
      // InStockOptions: InStockOptions,
      // WhetherOptions: WhetherOptions,
      // AssetSourceOptions: AssetSourceOptions,
      rules: {
        bedNo: [{
          required: true,
          message: "请输入床号",
          trigger: "blur",
        },],
        surgicalName: [{
          required: true,
          message: "请输入手术名称",
          trigger: "blur",
        },],
        date: [{
          required: true,
          message: "请选择手术时间",
          trigger: "blur",
        },],
        doctorName: [{
          required: true,
          message: "请选择主刀医生",
          trigger: "blur",
        },],
        patientNo: [{
          required: true,
          message: "请选择住院号",
          trigger: "blur",
        },],

      },
      childFormRules: {
        price: [{
          required: true,
          message: "请输入采购价",
          trigger: "blur",
        },],
        number: [{
          required: true,
          message: "数量不能为空",
          trigger: "blur",
        },
        {
          type: "number",
          min: 0.01,
          message: "数量必须大于0",
          trigger: "blur",
        },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      approveDisable: false,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      childForm: {},
      // showCapitalSource: false,
      // showCapitalSourceTwo: false,
      // showCapitalSourceThree: false,
      // capitalSourcemaxCount: 0,
      // fileId: 0,
      // fileName: '',
      // openViewer: false,
      opList: [],
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    if (query.isCopy == 1) {
      this.isCopy = true;
    }

    // if (query.editMode == 1) {
    //   this.editMode = true
    // }
    this.getSuppliers1("", 1);
    this.getProductList("");
    this.getPatientDetailList("");
    this.getUsers("");
    // this.getWarehouses('')
    this.getWarehousesBySessionWarehouseId("");
    this.getOneLevelWarehouses("");
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      this.GetDataAction({
        id,
      }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;
        this.getLocations(this.form.warehouseId);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });

        this.initWorkFlowProperty(this.form);

        if (
          this.formMode == 3 &&
          this.form.status == 1 &&
          this.form.approverIds &&
          this.form.approverIds.indexOf(this.userInfo.id + "") != -1
        ) {
          this.approveDisable = true;
        }

        if (res.returnData.supplierInfos) {
          res.returnData.supplierInfos.map((e) => {
            var supplier = this.STATIC_Suppliers.filter((s) => s.id == e.id);
            if (!supplier || supplier.length == 0) {
              this.STATIC_Suppliers.push(e);
            }
          });
        }

        if (res.returnData.supplierIds) {
          let arr = res.returnData.supplierIds.split(";").map((item) => {
            return +item;
          });
          this.$set(this.form, "supplierIdArr", arr);
        }
      });
    },
    // 保存
    submit () {
      var valdateResult = this.productDetailRepeatValidate(this.form.details);
      if (!valdateResult.flag) {
        this.$my_message(valdateResult.msg, "warning");
        return;
      }
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.form.supplierIds = this.form.supplierIdArr ?
          this.form.supplierIdArr.join(";") :
          "";

        let supplierProductIds = this.form.details.map((e) => e.supplierProductId);
        // if (!supplierProductIds || supplierProductIds.length == 0) {
        //   this.$my_message("存在没有供应商产品的明细表", "warning")
        //   return
        // }

        ValidateSupplierProducts({
          ids: supplierProductIds,
        })
          .then((res) => {
            if (res.returnData && res.returnData.length > 0) {
              const h = this.$createElement;
              let content = [];
              for (let i = 0; i < this.form.details.length; i++) {
                res.returnData.forEach((item) => {
                  if (this.form.details[i].supplierProductId == item.key) {
                    content.push(
                      h(
                        "p",
                        `第${i + 1}行：产品名称[${this.form.details[i].productName
                        }]，规格型号[${this.form.details[i].specName}]${item.errorMessage
                        }\n`
                      )
                    );
                  }
                });
              }
              content.push(h("p", `不审核仍可下单。`));

              return this.$confirm("提示", {
                title: "提示",
                type: "warning",
                customClass: "promptBox",
                message: h("div", content),
              });
            }
          })
          .then((res) => {
            return this.SaveDataAction(this.form).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;

          })
          .then((res) => {
            this.$my_message(`执行成功`, "success");
            sessionStorage.setItem("editMode", 0);
            // this.$router.push({ path: this.getMainPath(this.$route.path) });
            this.routePushWithParams(
              this.getMainPath(this.$route.path),
              this.$route.params
            );
          });
      });
    },
    resetForm () {
      this.form = {
        inStockType: 0,
        supplierId: "",
        supplierName: "",
        assetCheckNo: "",
        assetCheckId: "",
        state: 0,
        details: [],
        warehouseCategory: "",
        // "warehouseId": this.userInfo.defaultWarehouseId,
        // warehouseName: this.userInfo.defaultWarehouseName,
        warehouseManImplantsApplyrId: this.userInfo.defaultWarehouseManImplantsApplyrId,
        warehouseManImplantsApplyrName: this.userInfo.defaultWarehouseManImplantsApplyrName,
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        // date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        supplierIdArr: [],
        supplierIds: "",
        sex: 0,
        patientSexName: "",
        ImplantsApply: 0,
        state: 1,
        stateName: "待供应商确认",
        totalNumber: 0,
        totalAmount: 0,
        orgCode :sessionStorage.getItem('orgId'),
      };
      this.setDefaultWarehouseBySessionWarehouseId();
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },

    // 明细表
    handleAddChildForm () {
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
      this.form.details.push(this.childForm);

      this.getProductList("");
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });

      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        supplierProductId: "",
        productName: "",
        productId: "",
        specId: "",
        brand: "",
        supplierId: "",
        manufacturerId: "",
        unit: "",
        minUnit: "",
        stockNumber: "",
        undeliveredNumber: 0,
        number: 0,
        price: 0,
        amount: 0,
        remark: "",
        isHaveStock: true,
        packSpec: "",
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
      // this.resetDetailFormData();

      this.getProductList("");
    },
    pushChildForm (close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        // this.capitalSourceChange()
        let item = this.form.details.find(
          (e) =>
            e.$index != this.childForm.$index &&
            e.supplierProductId == this.childForm.supplierProductId //&&
          // e.price == this.childForm.price &&
          // e.locationName == this.childForm.locationName &&
          // e.assetSource == this.childForm.assetSource &&
          // e.packDesc == this.childForm.packDesc &&
          // e.manufacturerId == this.childForm.manufacturerId &&
          // e.certId == this.childForm.certId &&
          // e.brandId == this.childForm.brandId
        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑且有重复项
          this.$my_message(`当前产品信息已存在，请去子表编辑！`, "error");
          return;
        } else if (!item && this.editChildren) {
          // 编辑
          item = this.form.details.find((e) => e.$index == this.childForm.$index);
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    childNumberChange (row) {
      row.orderNumber = row.number;
      row.undeliveredNumber = row.number;
      row.unCheckedNumber = row.number;
      row.amount = (row.number * row.price).toFixed(4) * 1;
      // this.autoAmount();
      this.autoTotalAmount();
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(4) * 1;
    },
    autoTotalAmount () {
      console.log(234);
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber.toFixed(3) * 1;
      this.form.totalAmount = totalAmount.toFixed(4) * 1;
    },

    // change event
    doctorChange (val) {
      // console.log(val, "doctorChange")
      this.form.doctorUserId = val;
      // var arr = this.STATIC_Users.filter(e => e.id == val)
      // this.form.doctorName = arr[0].name
    },
    warehouseChange (val) {
      this.form.warehouseId = val;
    },
    supplierChange (val) {
      this.form.supplierIds = val.join(";");

      this.getProductList("");
    },
    opChange (val) {
      this.form.surgicalStentId = val;
      let arr = this.opList.filter((item) => item.id == val)[0];
      if (!arr) {
        return;
      }

      this.form.assistant = arr.assistant;
      this.form.phone = arr.phone;
      this.form.surgicalStentName = arr.name + " " + arr.categoryName;
      // this.form.assistant = arr.assistant
      // this.form.phone = arr.phone
      this.form.supplierIds = arr.supplierIds;

      GetSurgicalStentById({
        id: val,
      }).then((res) => {
        var result = res.returnData;
        if (result.supplierInfos) {
          result.supplierInfos.map((item) => {
            var l = this.STATIC_Suppliers.filter((e) => e.id == item.id);
            if (!l || l.length == 0) {
              this.STATIC_Suppliers.push(item);
            }
          });
        }

        if (result.details) {
          this.form.details = result.details;
          this.form.details.map((e, index) => {
            e.$index = index + 1;

            return e;
          });
        }

        if (arr.supplierIds) {
          let at = arr.supplierIds.split(";").map((item) => {
            return +item;
          });
          this.$set(this.form, "supplierIdArr", at);
        }
        this.autoTotalAmount();
      });
    },
    patientChange (val) {
      console.log(val, "patientChange");
      // this.form.patientId = val
      // let arr = this.STATIC_PatientDetails.filter(item => item.no == val)[0]
      let arr = this.STATIC_PatientDetails.filter((item) => item.id == val)[0];
      if (arr) {
        this.form.patientName = arr.name;
        this.form.patientId = arr.id;
        this.form.patientNo = arr.no;
        this.form.sex = arr.sex;
        this.form.patientSexName = arr.sexName;
        this.form.patientAge = this.jsGetAge(arr.birthday);
      } else {
        this.form.patientName = "";
        this.form.patientId = "";
        this.form.patientNo = "";
        this.form.sex = "";
        this.form.patientAge = "";
      }
    },
    productChange (row, val) {
      let id = row.id;
      row = Object.assign(row, val);
      row.id = id;
      row.supplierProductId = val.id;
      row.number = 1;
      row.stockNumber = 0;
      row.undeliveredNumber = row.number;
      row.unCheckedNumber = row.number;
      row.orderNumber = row.number;
      row.price = row.purchasePrice;
      row.amount = row.price * row.number;
      row.supplierProductNo = row.no;
      row.remark = "";

      this.autoTotalAmount();

      setTimeout(() => {
        document.getElementById("number" + (row.$index - 1)).focus();
        document.getElementById("number" + (row.$index - 1)).select();
      }, 1);
    },
    inputChange (row) {
      row.amount = row.price * row.number;
      this.autoTotalAmount();
    },

    getProductList (keyWord) {
      var user = this.userInfo;
      // query.pImplantsApplySize = 100
      // query.pImplantsApplyIndex = 1
      // query.isEnabled = 1
      // query.supplierId = this.form.supplierId
      // query.deptId = user.deptId
      // query.stockCategory = 2
      this.getSupplierProducts(
        //query)
        {
          keyWord: keyWord,
          // pImplantsApplySize: 100,
          // pImplantsApplyIndex: 1,
          isEnabled: 1,
          // supplierId: this.form.supplierId,
          deptId: user.deptId,
          stockCategory: 2,
          status: 2,
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  overflow: auto !important;
}

/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>

<style>
.promptBox {
  width: 800px !important;
  max-height: 300px;
}
</style>
